































import BankImg from '@/components/image/BankImg.vue'
import ItemCard from '@/components/card/ItemCard.vue'
import Translation from '@/mixins/Translation'
import {Component, Mixins, Prop} from 'vue-property-decorator'

@Component({
  components: {
    BankImg,
    ItemCard,
  },
})
export default class BankCard extends Mixins(Translation) {
  @Prop({default: null, type: String}) id: string
  @Prop({default: null, type: String}) code: string
  @Prop({default: null, type: String}) owner: string
  @Prop({default: '', type: String}) name: string
  @Prop({default: null, type: String}) number: string
  @Prop({default: false, type: Boolean}) empty: boolean
  @Prop({default: false, type: Boolean}) emptyCert: boolean
  @Prop({default: false, type: Boolean}) payment: boolean
  @Prop({default: null}) select: 'negative' | 'positive' | null
  @Prop({default: false, type: Boolean}) loading: boolean
  @Prop({default: false, type: Boolean}) isTransfer: boolean
  @Prop({default: false, type: Boolean}) isPayment: boolean

  outlineColors = {
    negative: 'danger-light',
    positive: 'primary-light',
  }

  get outline() {
    const {select} = this
    if(this.emptyCert && !this.isTransfer) return ''
    if(!select) {
      return select
    }
    return this.outlineColors[select]
  }

  get actions() {
    return [{
      title: this.number,
    }]
  }

  get emptyText() {
    const {ts} = this
    if(this.emptyCert) return `${ts('certificate')}로 ${ts('account')} 추가하기`
    return `${ts('bank-account')} ${ts('register')}하기`
  }

  get disabledCard() {
    if(this.emptyCert) return !this.isTransfer
    else if(this.payment) return !this.isPayment
    return false
  }
}
